import AlertsTab from './sidebar/AlertsTab'
import FriendsTab from './sidebar/FriendsTab'
import LogoutTab from './sidebar/LogoutTab'
import HomeTab from './sidebar/HomeTab'
import MessagesTab from './sidebar/MessagesTab'
import ProfileTab from './sidebar/ProfileTab'
import SettingsTab from './sidebar/SettingsTab'
import logo from '../assets/logo.png'
import GeneralContext from './contexts/GeneralContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import MenuTab from './sidebar/MenuTab/MenuTab'

function Sidebar() {
   const navigator = useNavigate()
   const {
      getWindowDimensions,
      showFullSize,
      setShowFullSize,
      setShowSemiSize,
   } = useContext(GeneralContext)

   const handleDimensions = () => {
      const width = getWindowDimensions()['width']

      if (width <= 900) {
         setShowFullSize(false)
      } else {
         setShowFullSize(true)
      }

      if (width <= 1200) {
         setShowSemiSize(true)
      }else {
         setShowSemiSize(false)
      }
   }

   useEffect(() => {
      handleDimensions()

      window.addEventListener('resize', handleDimensions)
   }, [])

   return (
      <div className="Sidebar">
         {showFullSize && (
            <div className="logoSidebar">
               <img src={logo} className="nav-logo" alt="logo" title="logo" />
            </div>
         )}

         <div className="tabs">
            <HomeTab />
            <ProfileTab />
            {/* <MessagesTab /> */}
            <FriendsTab />
            <AlertsTab />
            {!showFullSize && <MenuTab />}
         </div>
         {showFullSize && (
            <>
               <div className="friendsOnline"></div>
               <div className="footer">
                  <SettingsTab />
                  <LogoutTab />
               </div>
            </>
         )}
      </div>
   )
}
export default Sidebar
